<template>
    <div>
      Déconnexion en cours...
    </div>
  </template>
  
  <script>
  export default {
    async created() {
      await this.$store.dispatch('auth/logout');
      this.$router.push('/login'); // Ou '/', selon ton besoin
    }
  };
  </script>
  